import { Box, Skeleton } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreFinanceiroGeral } from '@/features/dashboard/api/getConsolidationScoreFinanceiroGeral.ts';
import ScoreFinanceiroGeralChart from './components/ScoreFinanceiroGeralChart.tsx';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const ScoreFinanceiroGeral = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreFinanceiroGeral(yearProp);
  const listYears = Object
    .keys(groupBy(data, 'ano'))
    .map((item) => Number(item))
    .sort((a, b) => b - a);

  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched && listYears.length) {
      setYear(listYears[0]);
    }
  }, [isFetched, listYears]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  return (
    <>
      <LoadingChart loading={isFetching} />

      {
        data?.length && (
          <ScoreFinanceiroGeralChart
            title={'Histórico financeiro dos alunos'}
            lineColor={'#15AB51'}
            pointColor={'#000'}
            data={data}
          />
        )
      }

      {
        isFetched && (
          <Box marginTop={'10px'}>
            <PeriodFilter year={year} years={listYears} onApplyFilter={onApplyFilter} />
          </Box>
        )
      }
    </>
  );
};

export default ScoreFinanceiroGeral;
